import { render, staticRenderFns } from "./ResultadoAxios.vue?vue&type=template&id=62497764&"
import script from "./ResultadoAxios.vue?vue&type=script&lang=js&"
export * from "./ResultadoAxios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports